module.exports = __webpack_public_path__ + "static/sp2.dc5a9571.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/sp2.png
// module id = 1378
// module chunks = 39761248111596 129519670211406